import React, { createContext, useState, useEffect } from 'react';
import Client from 'shopify-buy';

const client = Client.buildClient({
	domain: 'rayruebybetty.myshopify.com',
	storefrontAccessToken: '95757f3b766a3ee5489cff11f7eb4584'
});

const defaultValues = {
	isCartOpen: false,
	toggleCartOpen: () => {},
	cart: [],
	addProductToCart: () => {},
	removeProductFromCart: () => {},
	checkCoupon: () => {},
	client,
	checkout: {
		lineItems: []
	}
};

export const StoreContext = createContext(defaultValues);

// Check if it's a browser
const isBrowser = typeof window !== 'undefined';

export const StoreProvider = ({ children }) => {
	const [ checkout, setCheckout ] = useState(defaultValues.checkout);
	const [ isCartOpen, setCartOpen ] = useState(false);
	const [ quantity, setQuantity ] = useState(1);

	const toggleCartOpen = () => setCartOpen(!isCartOpen);

	useEffect(() => {
		initializeCheckout();
	}, []);

	const getNewId = async () => {
		try {
			const newCheckout = await client.checkout.create();

			if (isBrowser) {
				localStorage.setItem('checkout_id', newCheckout.id);
				localStorage.setItem('saved', new Date().getTime());
			}
			return newCheckout;
		} catch (e) {
			console.error(e);
		}
	};

	const initializeCheckout = async () => {
		try {
			// Check if id exists
			const currentCheckoutId = isBrowser ? localStorage.getItem('checkout_id') : null;

			let newCheckout = null;

			if (currentCheckoutId) {
				// If id exists, fetch checkout from Shopify

				newCheckout = await client.checkout.fetch(currentCheckoutId);

				let hours = 0.5;
				let saved = localStorage.getItem('saved');
				if (saved && new Date().getTime() - saved > hours * 60 * 60 * 1000) {
					localStorage.clear();
					newCheckout = await getNewId();
				} else if (newCheckout.completedAt) {
					newCheckout = await getNewId();
				}
			} else {
				// If id does not, create new checkout
				newCheckout = await getNewId();
			}

			// Set checkout to state

			setCheckout(newCheckout);
		} catch (e) {
			console.error(e);
		}
	};

	const addProductToCart = async (variantId) => {
		try {
			const newQuantity = Number(quantity);
			const lineItems = [
				{
					variantId,
					quantity: newQuantity
				}
			];

			const newCheckout = await client.checkout.addLineItems(checkout.id, lineItems);

			// Buy Now Button Code
			// window.open(addItems.webUrl, '_blank');

			setCheckout(newCheckout);
		} catch (e) {
			console.error(e);
		}
	};

	const removeProductFromCart = async (lineItemId) => {
		try {
			const newCheckout = await client.checkout.removeLineItems(checkout.id, [ lineItemId ]);
			setCheckout(newCheckout);
		} catch (e) {
			console.error(e);
		}
	};

	const checkCoupon = async (coupon) => {
		const newCheckout = await client.checkout.addDiscount(checkout.id, coupon);
		setCheckout(newCheckout);
	};

	const removeCoupon = async (coupon) => {
		const newCheckout = await client.checkout.removeDiscount(checkout.id, coupon);
		setCheckout(newCheckout);
	};

	const increaseQuantity = async (lineItemsToUpdate) => {
		const newCheckout = await client.checkout.updateLineItems(checkout.id, lineItemsToUpdate);
		setCheckout(newCheckout);
	};

	const decreaseQuantity = async (lineItemsToUpdate) => {
		const newCheckout = await client.checkout.updateLineItems(checkout.id, lineItemsToUpdate);
		setCheckout(newCheckout);
	};

	return (
		<StoreContext.Provider
			value={{
				...defaultValues,
				checkout,
				addProductToCart,
				toggleCartOpen,
				isCartOpen,
				removeProductFromCart,
				checkCoupon,
				removeCoupon,
				client,
				increaseQuantity,
				decreaseQuantity,
				quantity,
				setQuantity
			}}
		>
			{children}
		</StoreContext.Provider>
	);
};
